
<div
    class  ="nav-user-tab-item w-100"
>
    <c-column-header
        label = "Benutzer Stempel"
        class = "primary"
    />

    <msd-users
        v-model="user"
    />

    <div style="position: relative">
        <div
            v-if="signature"
            class="lm-border  pl-1 pr-0 pb-0"
            style="position:absolute; left: 8px; bottom: 8px; width: 100px"
        >
            <v-slider
                v-model="distance"
                thumb-label
                :thumb-size="24"
                :ripple="false"
                @change="onAdjustSignature"
                dense
                hide-details
            />
         </div>
        <div class="stamp-panel lm-border mt-3 pa-3" style="height: 300px">
            <img
                v-if = "stamp"
                :src = "stamp"
                alt  =""
                style="max-width:100%; height:auto"
            />
        </div>
    </div>
</div>
